import React, { useEffect, useMemo } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { useGroupSearch } from "hooks/citajteo/dl_group/useGroupSearch";
import { DlGroup } from "model/dl_group/DlGroup";

type GroupSelectProps<T extends FieldValues = FieldValues> = {
  control?: Control<T>;
  valueByField?: "id" | "slug";
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const GroupSelect = <T extends FieldValues = FieldValues>({
  control,
  valueByField = "id",
  defaultValue = "",
  label = "Tip korisnika",
  name = "uType",
  onSelect,
}: GroupSelectProps<T>) => {
  const dlGroups = useGroupSearch();
  const groupsOptions = useMemo(() => {
    if (!dlGroups || !dlGroups.items) {
      return [];
    }

    const options = dlGroups.items.map((dlGroup: DlGroup) => {
      const value = valueByField === "slug" ? dlGroup.slug : dlGroup.id;
      return {
        value,
        label: dlGroup.slug,
      };
    });

    return options;
  }, [dlGroups]);
  const { control: localControl, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    if (!control) {
      reset({
        [name]: defaultValue,
      });
    }
  }, [control, defaultValue, name, reset]);

  return (
    <>
      <SelectField
        name={name}
        control={(control ?? localControl) as Control<any>}
        label={label}
        defaultValue={defaultValue}
        options={groupsOptions}
        onSelect={onSelect}
      />
    </>
  );
};

export default GroupSelect;
